export default __webpack_public_path__ + "empty@2x.bb9cc7f4.jpg";